/**
 * @generated SignedSource<<811518c27dda13ead32b42ce958b2b81>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SubscriptionGetInvoiceEstimateMutation$variables = {
  planQuantity: number;
};
export type SubscriptionGetInvoiceEstimateMutation$data = {
  readonly getInvoiceEstimate: {
    readonly difference: number | null | undefined;
  };
};
export type SubscriptionGetInvoiceEstimateMutation = {
  response: SubscriptionGetInvoiceEstimateMutation$data;
  variables: SubscriptionGetInvoiceEstimateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "planQuantity"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "planQuantity",
        "variableName": "planQuantity"
      }
    ],
    "concreteType": "GetInvoiceEstimateResult",
    "kind": "LinkedField",
    "name": "getInvoiceEstimate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "difference",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SubscriptionGetInvoiceEstimateMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SubscriptionGetInvoiceEstimateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "81b5ff1de80fb5d9029d69b001f22fa2",
    "id": null,
    "metadata": {},
    "name": "SubscriptionGetInvoiceEstimateMutation",
    "operationKind": "mutation",
    "text": "mutation SubscriptionGetInvoiceEstimateMutation(\n  $planQuantity: Int!\n) {\n  getInvoiceEstimate(planQuantity: $planQuantity) {\n    difference\n  }\n}\n"
  }
};
})();

(node as any).hash = "2f09dafb7180a8bd01be6e019e4b7703";

export default node;
